import { render, staticRenderFns } from "./BundleProducts.vue?vue&type=template&id=a21e8b5c&"
import script from "./BundleProducts.vue?vue&type=script&lang=js&"
export * from "./BundleProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports